import styled from 'styled-components';

export const HeaderCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing['2.5']};
`;
